import { render, staticRenderFns } from "./QuarantineIndex.vue?vue&type=template&id=cfb15e80&"
import script from "./QuarantineIndex.vue?vue&type=script&lang=js&"
export * from "./QuarantineIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports